import React, { forwardRef } from 'react';
import { css, useTheme } from '@emotion/react';
import CustomerHtml from '@bbkFunnel/components/customer_html/customer_html';
import { type EmotionTheme } from '@bbkFunnel/pages/theme';

type Props = {
  title: React.ReactNode;
} & Omit<React.HTMLAttributes<HTMLDivElement>, 'title'>;
export const TitleTheme = forwardRef<HTMLSpanElement, Props>((props, ref) => {
  const { title, ...restProps } = props;
  const theme = useTheme() as EmotionTheme;

  const baseStyles = css({
    fontWeight: 'bold',
    fontSize: '2rem',
  });

  const titleThemeStyles = css({
    color:
      theme.modalTitleFontColor || theme.titleFontColor || theme.primaryColor,
    fontWeight: theme.titleFontWeight,
    fontSize: theme.titleFontSize,
    fontFamily: theme.titleFontFamily,
    textTransform: theme.titleTextTransform,
  });

  return (
    <div css={[baseStyles, titleThemeStyles]} {...restProps}>
      <span ref={ref}>
        <CustomerHtml value={title} />
      </span>
    </div>
  );
});
